import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Divider as MuiDivider,
} from "@mui/material";
import Section from "../../dynamic/Section";
import { Helmet } from "react-helmet-async";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

const Divider = styled(MuiDivider)(spacing);

function App() {
  const [pageConfig, setPageConfig] = useState({});
  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(true);

  async function apiGetData(iduidUser) {
    const token = sessionStorage.getItem("token");

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          iduser: iduidUser,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/userGetInfo2`,
        requestOptions
      );

      const responseData = await response.json();
      console.log("Risposta API:", responseData); // Per verificare la risposta

      if (responseData.status === -1) {
        sessionStorage.clear();
        navigate("/auth/sign-in");
      }
      setPageConfig(responseData.data);
    } catch (error) {
      console.error("Errore nella chiamata API:", error);
      return error;
    }
  }

  useEffect(() => {
    apiGetData()
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoadingPage(false));
  }, []);

  if (!pageConfig) return <Typography>Caricamento...</Typography>;

  return (
    <React.Fragment>
      <Helmet title={pageConfig.pageTitle} />
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <React.Fragment>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              {pageConfig.pageTitle}
            </Typography>
          </Box>
          <Divider sx={{ my: 4 }} />

          {pageConfig.sections.map((section, index) => (
            <Section key={index} section={section} />
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default App;
